module.exports = __webpack_public_path__ + "img/iseatu-1024-splash.2657bec5.png";